import { connect } from 'react-redux';
import { deleteAttributeTransform, deleteCodeContainer, deleteRecordTransform } from 'js/actions';
import ReusableTxDetailActions from './ReusableTxDetailActions';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

function mapStateToProps(state, ownProps) {
  const {
    entities: { dataSets },
  } = state;
  const { data } = ownProps;
  const dataSet = ownProps.dataSet || dataSets[data?.data_sets?.[0]];
  return {
    dataSet,
  };
}

function ReusableTxDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <ReusableTxDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default connect(mapStateToProps, {
  deleteAttributeTransform,
  deleteRecordTransform,
  deleteCodeContainer,
})(ReusableTxDetailActionsWithContext);
